// import { userCredentials } from './../../../../e2e/fixtures/config-data';
import { CookieStorage } from 'app/base/services/cookie-storage.service';
import { Injectable } from '@angular/core';

import { Observable ,  of } from 'rxjs';
import { UserService } from 'app/base/services/user.service';
import { LocalDataStoreService } from 'app/base/services/local-data-store.service';
// import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';

@Injectable()
export class LocalesResolveGuardService  {
  constructor(
    private cookieStorage: CookieStorage,
    private userService: UserService,
    private localDataStoreService: LocalDataStoreService
  ) {
  }

  resolve(): Observable<any> {
    if (this.localDataStoreService.localesList) {
      return of(this.localDataStoreService.localesList);
    }
    const token = this.cookieStorage.getCookie('token');
    if (token) {
      return this.userService.getLocales().pipe(map(res => {
        this.localDataStoreService.setLocales(res.data);
        return res;
      }));
    }
  }
}
